export default __webpack_public_path__ + "assets/icons/other.974b1eb8.svg";